var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseMenu = function SvgCloseMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.941 17.824 6.177 4.058a1.497 1.497 0 0 0-2.118 2.117l13.765 13.765a1.497 1.497 0 0 0 2.117-2.117"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.059 17.824 17.823 4.058a1.497 1.497 0 1 1 2.118 2.117L6.176 19.941a1.498 1.498 0 0 1-2.117-2.117"
  })));
};
export default SvgCloseMenu;